// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminTermsAcceptances = (client) => ({
    /**
     * `GET /admin/terms-acceptances`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminTermsAcceptancesList
     * @source apps/backend/src/api/admin/terms-acceptances/route.ts
     */
    list: (query, headers) => client.fetch("/admin/terms-acceptances", { method: "GET", query, headers }),
});
//# sourceMappingURL=terms-acceptances.js.map